export default __webpack_public_path__ + "static/media/arrow-down.08c9b552.svg";